export default __webpack_public_path__ + "static/media/visa-logo.4956728c.svg";